<template>
    <span><span class="curr-integer">{{dataSelf.integer}}<sub class="curr-fraction">.{{dataSelf.fraction}}</sub></span></span>
</template>

<script>
export default {
    props:{
        value:{
            type:[String,Number],
            required: false,
            default: function() {
                return "";
            }
        }
    },
    name:"user-currency",
    data() {
        return {
            valueSelf:{
                integer:"0",
                fraction:"00"
            }
            
        }
    },
    computed:{
        dataSelf(){
            let res = {
                integer:"0",
                fraction:"00"
            }
            if(this.value){
                let val = this.utils.splitK(this.value);
                [res.integer = '0', res.fraction = '00'] = val.split('.');
            }
            return res;
        }
    },
    methods: {
    }
};
</script>
<style scoped>
sub{
    position: relative;
    font-size: 75%;
    line-height: 0;
    top:0;
    vertical-align: baseline;
}
span{
    font-family:PingFangSC-Medium, "微软雅黑";
}
</style>


// WEBPACK FOOTER //
// src/components/user-currency/user-currency.vue